import type {
  ComposedInvoice,
  InvoiceActionRun,
  InvoiceDueInterest,
  InvoicePagination,
} from 'src/interfaces/invoice'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Deriving the
 * status chip, totals and type list belongs in the column definitions.
 */
export const getComposedInvoices = (state: State): ComposedInvoice[] => {
  return state.invoice.composedInvoices
}

export const getInvoicesPagination = (state: State): InvoicePagination => {
  return state.invoice.pagination
}

export const getInvoicesLoading = (state: State): boolean => {
  return state.invoice.invoicesLoading
}

export const getInvoicesError = (state: State): string | null => {
  return state.invoice.invoicesError
}

export const getInvoiceDueInterest = (state: State): InvoiceDueInterest | null => {
  return state.invoice.dueInterest
}

export const getInvoiceDueInterestLoading = (state: State): boolean => {
  return state.invoice.dueInterestLoading
}

export const getInvoiceDueInterestError = (state: State): string | null => {
  return state.invoice.dueInterestError
}

export const getInvoiceActionRun = (state: State): InvoiceActionRun | null => {
  return state.invoice.actionRun
}
